import { Base64 } from 'js-base64'
import {
  AdesaoConfiguracao,
  AdesaoConfiguracaoApi,
  AdesaoParentescoOption,
  ConfigData,
} from '../utils/interfaces'
import api from './api'

export const DEFAULT_ADESAO_CONFIG: AdesaoConfiguracao = {
  tamanhoCodigoValidador: 4,
  valorUnidadeReferencia: 54.82,
  urlSite: 'https://cibrius.com.br/',
  urlVideo:
    'https://www.youtube.com/embed/hUqfFta6v0E?si=_JJc4tG_cTqde8PV&amp;start=6',
  listaParentesco: [
    { label: 'Cônjuge', value: '1' },
    { label: 'Companheiro(a)', value: '2' },
    { label: 'Filho(a) não emancipado menor de 21 anos', value: '3' },
    { label: 'Filho(a) inválido(a)', value: '4' },
    { label: 'Pai/mãe', value: '5' },
    { label: 'Mãe inválida', value: '13' },
    {
      label:
        'Irmã(o) não emancipada(o) menor de 21 anos com dependência econômica',
      value: '6',
    },
    {
      label: 'Irmã(o) inválida(o) com dependência econômica',
      value: '7',
    },
    {
      label:
        'Enteado(a) não emancipado(a) menor de 21 anos com dependência econômica',
      value: '8',
    },
    {
      label: 'Enteado(a) inválido(a) com dependência econômica',
      value: '9',
    },
    {
      label:
        'Menor tutelado não emancipado menor de 21 anos com dependência econômica',
      value: '10',
    },
    {
      label: 'Menor tutelado inválido com dependência econômica',
      value: '11',
    },
    { label: 'Filho(a) maior de 21 anos', value: '12' },
    { label: 'Sobrinho', value: '14' },
    { label: 'Outros', value: '0' },
  ],
}

export function normalizeAdesaoConfig(
  data?: Partial<AdesaoConfiguracaoApi> | Partial<AdesaoConfiguracao>,
): AdesaoConfiguracao {
  const listaParentescoApi = Array.isArray(data?.listaParentesco)
    ? (data?.listaParentesco as AdesaoParentescoOption[])
    : undefined
  const listaParentesco =
    Array.isArray(listaParentescoApi) && listaParentescoApi.length > 0
      ? listaParentescoApi.map((item: AdesaoParentescoOption) => ({
          label: item.label,
          value: String(item.value),
        }))
      : DEFAULT_ADESAO_CONFIG.listaParentesco

  return {
    tamanhoCodigoValidador:
      typeof data?.tamanhoCodigoValidador === 'number' &&
      data.tamanhoCodigoValidador > 0
        ? data.tamanhoCodigoValidador
        : DEFAULT_ADESAO_CONFIG.tamanhoCodigoValidador,
    valorUnidadeReferencia:
      typeof data?.valorUnidadeReferencia === 'number' &&
      data.valorUnidadeReferencia > 0
        ? data.valorUnidadeReferencia
        : DEFAULT_ADESAO_CONFIG.valorUnidadeReferencia,
    urlSite:
      typeof data?.urlSite === 'string' && data.urlSite.trim()
        ? data.urlSite
        : DEFAULT_ADESAO_CONFIG.urlSite,
    urlVideo:
      typeof data?.urlVideo === 'string' && data.urlVideo.trim()
        ? data.urlVideo
        : DEFAULT_ADESAO_CONFIG.urlVideo,
    listaParentesco,
  }
}

export async function fetchAdesaoConfig(
  configData: Pick<ConfigData, 'codCliente' | 'tipo' | 'plano'>,
): Promise<AdesaoConfiguracao> {
  const parametros = Base64.encode(
    `{"versao":"${configData.tipo}","plano":"${configData.plano}","cliente":"${configData.codCliente}"}`,
  )
  const parametrosFinal = Base64.encode(parametros)

  const response = await api.get(
    `wsConfiguracaoAdesao.rule?sys=ADZ&Entrada=${parametrosFinal}`,
  )

  return normalizeAdesaoConfig(response.data)
}
